import Loader from '@shared/components/reusables/loader';
import { Label } from '@design-system/label';
import { Switch } from '@design-system/switch';
import { useGetPlansList } from '@features/settings/pages/billing/services/get-plans';
import { useState } from 'react';
import { useSubscribeToPlan } from '@features/settings/pages/billing/services/subscribe-to-plan';
import { useSubscribeToFreeTrial } from '@features/settings/pages/billing/services/subscribe-free-trial';
import useCheckSubscription from '@shared/hooks/use-check-subscription';
import { Button } from '@design-system/button';
import { PUBLIC_PATH } from '@core/router/paths';
import { mockedPlansAndPricing } from '@features/settings/pages/billing/pricing/mock-data';
import MockedPriceCard from './mocked-price-card';
import { Dialog, DialogContent } from '@design-system/dialog';
import PlanDialog from '@shared/components/common/plan-dialog';

const UpgradeTab = () => {
  const [open, setOpen] = useState(false);
  const [yearly, setYearly] = useState(false);
  const { isFetching, data } = useGetPlansList();
  const { isFreeTrial, subscription } = useCheckSubscription();

  const { mutateAsync: subscribeToPlan } = useSubscribeToPlan();
  const { mutateAsync: subscribeToFreeTrial } = useSubscribeToFreeTrial();

  const handleSubscribe = (id: number) => {
    if (!id) return;
    subscribeToPlan({
      id,
      billing_interval: yearly ? 'YEARLY' : 'MONTHLY',
    }).then((data) => {
      window.location.href = data.session_url;
    });
  };

  const handleSubscribeFreeTrial = (id: number) => {
    subscribeToFreeTrial(id).then(() => setOpen(true));
  };

  if (isFetching) return <Loader height={1} />;

  return (
    <div className='mb-5'>
      <div className='flex items-center justify-center mt-5 gap-2'>
        <Label
          htmlFor='plan'
          className='text-base font-extralight text-gray-800 mb-0'
        >
          Monthly
        </Label>
        <Switch
          id='plan'
          onCheckedChange={setYearly}
          defaultChecked={false}
        />
        <Label
          htmlFor='plan'
          className='text-base font-extralight text-gray-800 mb-0'
        >
          Yearly (save more)
        </Label>
      </div>
      <div className='grid md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-4 gap-4 scroll-auto items-stretch'>
        {/* {plans?.map((plan) => (
            <CRMPricingCard
              plan={plan}
              selected={subscription?.plan.id === plan.id}
              key={plan.id}
              yearly={yearly}
              handleSubscribe={
                isFreeTrial
                  ? handleSubscribeFreeTrial
                  : handleSubscribe
              }
            />
          ))} */}
        {mockedPlansAndPricing.map((plan) => (
          <MockedPriceCard
            plan={plan}
            key={plan.id}
            selectedPlanId={subscription?.plan?.id}
            yearly={yearly}
            plans={data}
            handleSubscribe={
              isFreeTrial ? handleSubscribeFreeTrial : handleSubscribe
            }
          />
        ))}
      </div>
      <div className='flex justify-center mt-14'>
        <Button
          variant='primaryOutline'
          onClick={() =>
            window.open(PUBLIC_PATH.PLANS_AND_SUB_DETAILS, '_blank')
          }
        >
          Compare All Plans in Details
        </Button>
      </div>
      <Dialog
        open={open}
        onOpenChange={setOpen}
      >
        <DialogContent align='center'>
          <PlanDialog />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UpgradeTab;
